import React from 'react';

import BlockContent from './BlockContent';
import Illustration from './Illustration';

export default function FullWidthSection({ section }) {
  const { illustration, blockContent } = section;
  return (
    <>
      {section && (
        <div className="full-width-section">
          <BlockContent content={blockContent} />
          <Illustration illustration={illustration} />
        </div>
      )}
    </>
  );
}
